import { render } from "./StaffPage_info.vue?vue&type=template&id=b8a01ff4&scoped=true"
import script from "./StaffPage_info.vue?vue&type=script&lang=js"
export * from "./StaffPage_info.vue?vue&type=script&lang=js"

import "./StaffPage_info.vue?vue&type=style&index=0&id=b8a01ff4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a01ff4"]])

export default __exports__